export const Constants = {
	appGuideUrl: 'https://docs.vaisala.com/search/all?filters=Document_type~%2522User+guide%2522*Product~%2522MD30%2522*ft%253AisPublication~%2522true%2522&content-lang=en-US',
	mainPage: 'https://www.vaisala.com/en/support/md30'
};
